module.exports = __webpack_public_path__ + "static/media/3-circles.5becc60b.png";